import { render } from "./FoodDetailLoader.vue?vue&type=template&id=a4c92e74"
import script from "./FoodDetailLoader.vue?vue&type=script&lang=js"
export * from "./FoodDetailLoader.vue?vue&type=script&lang=js"

import "./FoodDetailLoader.vue?vue&type=style&index=0&id=a4c92e74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__